module.exports = __webpack_public_path__ + "static/assets/9639f0b66198be1fe2d138d82a1a3bf9.png";